import {IUser} from '@/_objects/IUser';
import {getSelf, login, forgot, verifyResetToken, resetPW, refreshToken} from '@/_services/user.services';
import router from "@/router";

export interface IAccountState {
    user?: IUser;
}

export const enum ACCOUNT_ACTION {
    LOGIN = 'account/login',
    LOGOFF = 'account/logoff',
    FORGOT = 'account/forgot',
    VERIFYRESETTOKEN = 'account/verifyResetToken',
    RESETPW = 'account/resetPW',
    SELF = 'account/getSelf',
    IS_AUTHENTICATED = 'account/isAuthenticated',
    REFRESH_TOKEN = 'account/refreshToken',
}

const state: IAccountState = {user: undefined};

const actions = {
    async refreshToken() {
        const apiToken: string = await refreshToken();
        if (apiToken) {
            (window as any).$cookies.set('token', apiToken, 0);
            (window as any).$cookies.set('tokenDate', new Date(), 0);
            return true;
        } else {
            return false;
        }
    },

    async login({dispatch, commit}: any, {email, password}: any): Promise<boolean> {
        try {
            const apiToken: string = await login(email, password);
            if (apiToken) {
                (window as any).$cookies.set('token', apiToken, 0);
                (window as any).$cookies.set('tokenDate', new Date(), 0);
                router.push("/secure/dashboard");
                return true;
            } else {
                return false;
            }

        } catch (err) {
            // Do nothing
            return false;
        }
    },
    async forgot({dispatch, commit}: any, {email}: any): Promise<boolean> {
        try {
            const status: string = await forgot(email);
            if (status) {
                return true;
            } else {
                return false;
            }

        } catch (err) {
            // Do nothing
            return false;
        }
    },

    async verifyResetToken({dispatch, commit}: any, {token}: any): Promise<boolean> {
        try {
            const status: string = await verifyResetToken(token);

            if (status) {
                return true;
            } else {
                return false;
            }
        } catch (err) {
            // Do nothing
            return false;
        }
    },
    async resetPW({dispatch, commit}: any, {token, password, confirmPassword}: any): Promise<boolean> {
        try {
            const status: string = await resetPW(token, password, confirmPassword);
            if (status) {
                return true;
            } else {
                return false;
            }

        } catch (err) {
            // Do nothing
            return false;
        }
    },
    async getSelf({dispatch, commit}: any): Promise<boolean> {
        try {
            const user: IUser = await getSelf();
            if (user) {
                commit('saveUser', user);
                return true;
            } else {
                return false;
            }

        } catch (err) {
            // Do nothing
            return false;
        }
    },
    logoff({dispatch, commit}: any) {
        (window as any).$cookies.remove("token");
        (window as any).$cookies.remove("tokenDate");
        commit('saveUser', undefined);
        router.push("/public/login");
    },
};

const mutations = {
    saveUser(newState: IAccountState, newUser: IUser) {
        newState.user = newUser;
    },
};

const getters = {
    isAuthenticated: (currentState: IAccountState) => {
        return !!currentState.user;
    },
};

export const account = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
